import { CompanyRepository } from "core/repository";
import CompanyFormCreatePresenter from "./company-form-create.presenter";

class CompanyFormEditPresenter extends CompanyFormCreatePresenter {
  initialState() {
    return {
      ...super.initialState(),
      creating: false,
      title: "Editar Empresa"
    };
  }

  async onStart() {
    this.companyUuid = this.routeParams.companyUuid;
    await super.onStart();
  }

  async getCompany() {
    return await CompanyRepository.getOnline(this.companyUuid);
  }

  async callRepository(params) {
    return await CompanyRepository.update(this.companyUuid, params);
  }
}

export default CompanyFormEditPresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/company-form-edit.presenter.js